<template>
  <div id="Users">
    <v-tabs v-model="tab" color="primary">
      <v-tab v-for="(item, i) in tabsUsers" :key="i" :disabled="loadingTabs || superAdmin" class="pa-4" >
        {{item.text}}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, i) in tabsUsers" :key="i">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-spacer/>
                <v-form lazy-validation :ref="`searchValidation_${i}`">
                  <v-text-field
                    v-model="search"
                    @click:append="searching(i)"
                    @keyup.enter="searching(i)"
                    :rules="rules.textNoSpecialChars"
                    :placeholder="$t('general.search')"
                    style="max-width: 250px"
                    dense
                    outlined
                    hide-details
                    clearable
                    append-icon="search"
                    class="mr-2"
                  />
                </v-form>
                <v-btn color="primary" depressed @click="dialogForm=true">{{$t('general.add')}} {{ addUserTypeText }}</v-btn>
              </v-card-title>
              <v-card-text>
                <v-overlay absolute opacity="0" :value="loadTable"/>
                <v-data-table
                  :headers="headers"
                  :items="users"
                  :options.sync="optionsDataTable"
                  :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
                  :server-items-length="optionsDataTable.total"
                  :loading="loadTable"
                  @update:page="getByTag()"
                  @update:items-per-page="getByTag()"
                  @update:sort-by="getByTag()"
                  @update:sort-desc="getByTag()"
                >
                  <template v-slot:item="props" >
                    <tr>
                      <td align="left">{{props.item.name}}</td>
                      <td v-if="addUserType === 'clients'" align="left">{{props.item.contact}}</td>
                      <td v-if="addUserType !== 'clients'" align="left">{{props.item.last_name}}</td>
                      <td align="left" v-if="addUserType === 'inspectors' || addUserType === 'administrators'">{{props.item.email}}</td>
                      <td v-if="userLogged.roles && userLogged.roles[0].id === 1">{{ props.item.companies[0].name }}</td>
                      <td v-if="addUserType === 'operators'" align="left">{{props.item.licence_number}}</td>
                      <td v-if="addUserType === 'operators'" align="left">{{props.item.credential_number}}</td>
                      <td v-if="addUserType !== 'clients' && addUserType !== 'operators'" align="left">{{props.item.phone}}</td>
                      <td v-if="addUserType === 'inspectors'" align="left">
                        <span v-for="(site, index) in props.item.sites" :key="index">
                          {{ site.name }}<span v-if="index < props.item.sites.length - 1">, </span>
                        </span>
                      </td>
                      <td align="left">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon class="mr-4" small @click="edit(props.item)" v-on="on">far fa-edit</v-icon>
                          </template>
                          <span>{{$t('general.edit')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small @click="remove(props.item)" v-on="on">far fa-trash-alt</v-icon>
                          </template>
                          <span>{{$t('general.delete')}}</span>
                        </v-tooltip>
                       <v-tooltip bottom v-if="addUserType === 'operators'">
                          <template v-slot:activator="{ on }">
                            <v-icon class="ml-4" small
                              @click="props.item.user && props.item.user.length > 0 ? null : openSendModal(props.item)"
                              v-on="on" :disabled="props.item.user && props.item.user.length > 0">
                              fas fa-user-check
                            </v-icon>
                          </template>
                          <span>{{$t('general.assign')}}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('users.delMessage')}}?</p>
          <p v-if="addUserType === 'clients'"><span class="font-weight-black error--text">{{$t('general.name')}}: </span> {{removedItem.name}}</p>
          <p v-else><span class="font-weight-black error--text">{{$t('general.name')}}: </span> {{removedItem.name + ' ' + removedItem.last_name}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="close" color="error" text>{{$t('general.cancel')}}</v-btn>
          <v-btn @click="deleteItem" :disabled="loading" :loading="loading" color="error" depressed>{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogForm" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="primary--text">{{titleForm}}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form v-model="valid" lazy-validation ref="form">
            <v-row v-if="addUserType === 'clients'" dense>
              <v-col cols="12" v-for="(client, index) in clients" :key="index">
                <v-row dense>
                  <v-col cols="5">
                    <v-text-field v-model="client.name" :label="$t('general.name')" :rules="rules.textRules" outlined dense>
                      <template v-slot:label>
                        <span>{{$t('general.name')}}</span><span class="error--text">&nbsp;*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="client.contact" :label="$t('address.social_reason')" :rules="rules.textRules" outlined dense>
                      <template v-slot:label>
                        <span>{{$t('address.social_reason')}}</span><span class="error--text">&nbsp;*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col v-if="isNew" cols="1" class="align-center"> 
                    <!-- remover icon en la siguiente fila para tome el diseño seleccionado -->
                    <v-btn v-if="index === clients.length - 1" @click="addClient(index)" icon :loading="loadingBtn" depressed class="mr-2" color="primary">
                      <v-icon small>fas fa-plus</v-icon>
                    </v-btn>
                    <!-- Filas anteriores: botón eliminar -->
                    <v-btn v-else icon color="error" @click="deleteClient(index)">
                      <v-icon small>fas fa-trash</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-else dense>
              <v-col cols="6">
                <v-text-field v-model="formData.name" :label="$t('general.name')" :rules="rules.textRulesStrict" outlined dense>
                    <template v-slot:label>
                      <span>{{$t('general.name')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formData.last_name" :label="$t('general.lastNames')" :rules="rules.textRulesStrict" outlined dense>
                  <template v-slot:label>
                    <span>{{$t('general.lastNames')}}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col v-if="addUserType !== 'operators'" cols="6">
                <v-text-field v-model="formData.email" :label="$t('general.email')" :rules="rules.email" outlined dense>
                  <template v-slot:label>
                    <span>{{$t('general.email')}}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col v-if="addUserType !== 'operators'" cols="6">
                <v-text-field v-if="isNew" v-model="formData.password" @click:append="viewPass = !viewPass" :rules="rules.validPassword" :type="!viewPass ? 'password' : 'text'" :append-icon="!viewPass ? 'visibility' : 'visibility_off'" outlined dense>
                  <template v-slot:label>
                    <span>{{$t('login.password')}}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-text-field>
                <v-text-field v-else v-model="formData.password" @click:append="viewPass = !viewPass" :label="$t('login.password')" :type="!viewPass ? 'password' : 'text'" :append-icon="!viewPass ? 'visibility' : 'visibility_off'" dense outlined/>
              </v-col>
              <v-col v-if="addUserType === 'operators'" cols="12">
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="formData.vigenteLicense" :rules="rules.textNoSpecialCharsFilters" :label="$t('general.vigenteLicense')" v-bind="attrs" v-on="on" outlined dense prepend-icon="event" readonly/>
                    </template>
                    <v-date-picker v-model="formData.vigenteLicense" @input="menu = false" no-title color="primary"/>
                  </v-menu>
              </v-col>
              <v-col v-if="addUserType === 'operators'" cols="6">
                <v-text-field v-model="formData.credential_number" :label="$t('general.credentialNumber')" :rules="rules.textNoSpecialCharsFilters" outlined dense/>
              </v-col>
              <v-col v-if="addUserType === 'operators'" cols="6">
                <v-text-field v-model="formData.license_number" :label="$t('general.numberLicense')" :rules="rules.textNoSpecialCharsFilters" outlined dense/>
              </v-col>
              <v-col v-if="addUserType !== 'operators'" cols="6">
                <v-text-field v-model="formData.phone" :label="$t('general.phone')" :rules="rules.phoneNoRequiredRules" outlined dense/>
              </v-col>
              <v-col v-if="addUserType === 'inspectors'" cols="6">
                <v-autocomplete v-model="formData.site_ids" :items="siteCapitalizeWords"  item-text="name" item-value="id" outlined dense multiple>
                  <template v-slot:label>
                    <span>{{$t('general.site')}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="!isNew && addUserType === 'operators' && formData.photoCredentialView" cols="4">
                <v-img :src="formData.photoCredentialView.public_url" max-height="200" max-width="250" contain/>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="!isNew && addUserType === 'operators' && formData.photoLicenseView" cols="4">
                <v-img :src="formData.photoLicenseView.public_url" max-height="200" max-width="250" contain />
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="!isNew && addUserType === 'operators' && formData.photoUserView" cols="4">
                <v-img :src="formData.photoUserView.public_url" max-height="200" max-width="250" contain/>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="!isNew && addUserType === 'operators'" cols="4">
                <v-checkbox v-model="checkPhotoCredential" :label="$t('general.updatePhotoCredential')"></v-checkbox>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="!isNew && addUserType === 'operators'" cols="4">
                <v-checkbox v-model="checkPhotoLicense" :label="$t('general.updatePhotoLicense')"></v-checkbox>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="!isNew && addUserType === 'operators'" cols="4">
                <v-checkbox v-model="checkPhotoOperator" :label="$t('general.updatePhotoOperator')"></v-checkbox>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="addUserType === 'operators' && ((!isNew && checkPhotoCredential) || isNew)" cols="4">
                <label>{{ $t('general.photoCredential') }}</label>
                <vue-dropzone 
                  ref="credentialDropzone" 
                  id="credentialDropzone" 
                  :options="dropzoneOptions"
                  @vdropzone-file-added="handleFileAddedCredential"
                  @vdropzone-removed-file="handleFileRemovedCredential">
                </vue-dropzone>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="addUserType === 'operators' && ((!isNew && checkPhotoLicense) || isNew)" cols="4">
                <label>{{ $t('general.photoLicense') }}</label>
                <vue-dropzone 
                  ref="licenseDropzone" 
                  id="licenseDropzone" 
                  :options="dropzoneOptionsLicense" 
                  @vdropzone-file-added="handleFileAddedLicense"
                  @vdropzone-removed-file="handleFileRemovedLicense">
                </vue-dropzone>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col v-if="addUserType === 'operators' && ((!isNew && checkPhotoOperator) || isNew)" cols="4">
                <label>{{ $t('general.photoOperator') }}</label>
                <vue-dropzone 
                  ref="photoUserDropzone" 
                  id="photoUserDropzone" 
                  :options="dropzoneOptionsPhotoUser" 
                  @vdropzone-file-added="handleFileAddedPhotoUser"
                  @vdropzone-removed-file="handleFileRemovedPhotoUser">
                </vue-dropzone>
              </v-col>
              <v-col v-else cols="4"></v-col>
              <v-col cols="6" v-if="userLogged.roles && userLogged.roles[0].id === 1 && addUserType === 'administrators'">
                <v-autocomplete v-model="formData.company_id" :items="companies" :rules="rules.required" outlined dense item-text="name" item-value="id" :disabled="!isNew">
                  <template v-slot:label>
                    <span>{{$t('general.company')}}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn @click="save()" :loading="loadingBtn" depressed class="float-right" color="primary">
                  {{$t('general.save')}}
                </v-btn>
                <v-btn @click="closeForm" :disabled="loadingBtn" class="float-right mr-2" color="primary" outlined>
                  {{$t('general.cancel')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

  <v-dialog v-model="dialogSend" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="primary--text">{{$t('general.assignOperatorInspector')}}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form v-model="validSend" lazy-validation ref="formSend">
            <v-row dense>
              <v-col cols="6">
                <v-text-field v-model="selectedOperatorToSend.name" :label="$t('general.name')" outlined dense
                  disabled />
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="selectedOperatorToSend.last_name" :label="$t('general.lastNames')" outlined dense
                  disabled />
              </v-col>

              <v-col cols="6">
                <v-text-field v-model="selectedOperatorToSend.email" :label="$t('general.email')" :rules="rules.email"
                  outlined dense>
                  <template v-slot:label>
                    <span>{{ $t('general.email') }}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="selectedOperatorToSend.password" @click:append="viewPassSend = !viewPassSend"
                  :rules="rules.validPassword" :type="!viewPassSend ? 'password' : 'text'"
                  :append-icon="!viewPassSend ? 'visibility' : 'visibility_off'" outlined dense>
                  <template v-slot:label>
                    <span>{{ $t('login.password') }}</span><span class="error--text">&nbsp;*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pt-4">
                <v-btn @click="sendInspector" :loading="loadingBtn" depressed class="float-right" color="primary">
                  {{$t('general.assign')}}
                </v-btn>
                <v-btn @click="closeSendModal" :disabled="loadingBtn" class="float-right mr-2" color="primary" outlined>
                  {{ $t('general.cancel') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import imageCompression from 'browser-image-compression'

export default {
  name: 'Users',
  components: {
    vueDropzone: vue2Dropzone,
  },
  data () {
    return {
      dialog: false,
      dialogForm: false,
      loadTable: true,
      loading: false,
      search: '',
      canEdit: false,
      pageCount: 0,
      optionsDataTable: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      removedItem: {
        name: '',
        last_name: '',
        roles: [
          {
            name: ''
          }
        ]
      },
      dialogSend: false,
      validSend: false,
      viewPassSend: false,
      selectedOperatorToSend: {
        id: null,
        name: '',
        last_name: '',
        email: '',
        password: ''
      },
      users: [],
      tab: 0,
      loadingTabs: false,
      role:'INSPECTOR',
      formData: {
        name: '',
        last_name: '',
        email: '',
        password: '',
        phone: '',
        license_number: '',
        photoLicense: null,
        credential_number: '',
        photoCredential: null,
        vigenteLicense: null,
        rolId: null,
        company_id: null,
        photoUser: null,
        photoLicenseView: null,
        photoCredentialView: null,
        photoUserView: null, 
      },
      valid: false,
      isNew: true,
      viewPass: false,
      loadingBtn: false,
      menu: false,
      dropzoneOptions: {
        url: '/no-enviar-automaticamente',
        dictDefaultMessage: `<h1 class="text-center"><i class="fas fa-upload"></i></h1></p><p class="text-center">${this.$t('dropzone.credentialOperator', { size: '5', unit: 'MB' })}</p>`,
        dictRemoveFile: this.$t('dropzone.removeFile'),
        autoProcessQueue: false,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 5,
        acceptedFiles: '.jpg, .png, jpeg',
      },
      dropzoneOptionsLicense: {
        url: '/no-enviar-automaticamente',
        dictDefaultMessage: `<h1 class="text-center"><i class="fas fa-upload"></i></h1></p><p class="text-center">${this.$t('dropzone.licenseOperator', { size: '5', unit: 'MB' })}</p>`,
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: this.$t('dropzone.removeFile'),
        maxFiles: 1,
        maxFilesize: 5,
        acceptedFiles: '.jpg, .png, jpeg',
      },
      dropzoneOptionsPhotoUser: {
        url: '/no-enviar-automaticamente',
        dictDefaultMessage: `<h1 class="text-center"><i class="fas fa-upload"></i></h1></p><p class="text-center">${this.$t('dropzone.photoOperator', { size: '5', unit: 'MB' })}</p>`,
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: this.$t('dropzone.removeFile'),
        maxFiles: 1,
        maxFilesize: 5,
        acceptedFiles: '.jpg, .png, jpeg',
      },
      checkPhotoOperator: false,
      checkPhotoCredential: false,
      checkPhotoLicense: false,
      isFirstCharge:true,
      clients: [{name: '', contact: ''}],
      companies: [],
      sites: []
    }
  },
  watch: {
    tab(){
      this.users = []
      this.cleanOptions()
    },
    userLogged (val) {
      if (val.roles && val.roles[0].id === 1) this.getCompanies()
    } 
  },
  computed: {
    siteCapitalizeWords(){
      if (this.sites.length === 0) return []

      return this.sites.map(site => {
        return {
          ...site,
          name: this.capitalizeWords(site.name)
        }
      })
    },
    superAdmin() {
      if(this.userLogged.roles && this.userLogged.roles[0].id === 1) {
        this.tab = 3
        return true
      }
      return false
    },
    rules () {
      return this.$validationRules()
    },
    titleForm(){
      let saveText = this.isNew ? this.$t('general.add') : this.$t('general.edit')
      return saveText + ' ' + this.addUserTypeText
    },
    tabsUsers(){
      return [
        {text: this.$t('general.inspectores'), value: 'inspectors'},
        {text: this.$t('general.operators'), value: 'operators'},
        {text: this.$t('general.clients'), value: 'clients'},
        {text: this.$t('general.administrators'), value: 'administrators'}
      ]
    },
    addUserType(){
      return this.tabsUsers[this.tab].value
    },
    addUserTypeText(){
      return this.tabsUsers[this.tab].text
    },
    headers () {
      let headersBase = [
        {
          text: this.$t('general.name'),
          value: 'name',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.lastNames'),
          value: 'last_name',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.email'),
          value: 'email',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.licence'),
          value: 'license_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.credential'),
          value: 'credential',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.phone'),
          value: 'phone',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
      
      if (this.addUserType === 'inspectors') {
        headersBase = headersBase.filter(h => h.value !== 'license_number' && h.value !== 'credential')
        headersBase.splice(4, 0, { text: this.$t('general.yard'), value: 'sites', align: 'left', sortable: false })
      }

      if (this.addUserType === 'operators') {
        headersBase = headersBase.filter(h => h.value !== 'email' && h.value !== 'phone')
      }

      if (this.addUserType === 'clients') {
        headersBase = headersBase.filter(h => h.value === 'name')
        headersBase.push(
          {
            text: this.$t('address.social_reason'),
            value: 'contact',
            align: 'left',
            sortable: true
          },
          {
            text: this.$t('general.actions'),
            align: 'left',
            sortable: false
          }
        )
      }

      if (this.addUserType === 'administrators') {
        headersBase = headersBase.filter(h => h.value !== 'license_number' && h.value !== 'credential')
        if(this.userLogged.roles && this.userLogged.roles[0].id === 1){
          headersBase.splice(3, 0, { text: this.$t('general.company'), value: 'company', align: 'left', sortable: false })
        }
      }

      return headersBase
    },
    userLogged () {
      return this.$store.state.userLogged
    }
  },
  created () {
    this.getByTag()
    if (this.userLogged.roles && this.userLogged.roles[0].id === 1) this.getCompanies()
    this.$store.dispatch('sites/get', {event: {item: {perPage: -1, page: 1}, context: this}})
  },
  methods: {
    openSendModal(item) {
      this.selectedOperatorToSend = {
        id: item.id,
        name: item.name,
        last_name: item.last_name,
        email: '',
        password: ''
      };

      if (this.$refs.formSend) {
        this.$refs.formSend.resetValidation();
      }

      this.dialogSend = true;
    },
    closeSendModal() {
      this.dialogSend = false;
      this.viewPassSend = false;
      this.loadingBtn = false;
      if (this.$refs.formSend) {
        this.$refs.formSend.resetValidation();
      }
    },
    sendInspector() {
      if (this.$refs.formSend.validate()) {
        this.loadingBtn = true;
        this.$store.dispatch('users/postOperatorAndInspector', {
          event: {
            item: {
              id_operator: this.selectedOperatorToSend.id,
              email: this.selectedOperatorToSend.email,
              password: this.selectedOperatorToSend.password
            },
            context: this
          }
        });
      }
    },
    capitalizeWords(str) {
      if (!str) return ''
      
      return str
        .toLowerCase()
        .replace(/(^|\s)\p{L}/gu, c => c.toUpperCase());
    },
    getCompanies(){
      this.$store.dispatch('company/getCompanyBySuperAdmin', {event: {item: {perPage: -1, page: 1}, context: this}})
    },
    addClient(index){
      const client = this.clients[index];

      if(!this.$refs.form.validate()) return this.showNotification(this.$t('validation.errorData'), 'warn', -1)

      // Validar campos vacíos
      if (!client.name || !client.contact) return this.showNotification(this.$t('validation.addData'), 'warn', -1)
        
      // Agregar nueva fila
      this.clients.push({ name: '', contact: '' });
    },
    deleteClient(index){
      if (this.clients.length > 1) { // opcional: evitar que se quede sin filas
        this.clients.splice(index, 1)
      }
    },
    async imageCompressionMethod (file) {
      const maxFileSizeMB = 2
      const currentSizeMB = file.size / 1024 / 1024

      const compressOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }

      let compressedFile = file

      // Comprimir solo si pesa más de 2MB
      if (currentSizeMB > maxFileSizeMB) {
        const compressedBlob = await imageCompression(file, compressOptions)

        // 🔥 Convertir Blob → File con mismo nombre y tipo original
        compressedFile = new File([compressedBlob], file.name, {
          type: file.type || 'image/jpeg',
          lastModified: Date.now(),
        })
      }

      return compressedFile
    },
    handleFileAddedCredential(file) {
      this.formData.photoCredential = file
    },
    handleFileRemovedCredential() {
      this.formData.photoCredential = null
    },
    handleFileAddedLicense(file) {
      this.formData.photoLicense = file
    },
    handleFileRemovedLicense() {
      this.formData.photoLicense = null
    },
    handleFileAddedPhotoUser(file) {
      this.formData.photoUser = file
    },
    handleFileRemovedPhotoUser() {
      this.formData.photoUser = null
    },
    closeForm() {
      this.dialogForm = false
      this.$refs.form.resetValidation()
      this.formData = this.defaultFormData()
      this.viewPass = false
      this.loadingBtn = false
      if(this.addUserType === 'operators'){
        this.checkPhotoOperator = false
        this.checkPhotoCredential = false
        this.checkPhotoLicense = false
        if(this.isNew || this.checkPhotoLicense) this.$refs.licenseDropzone.removeAllFiles()
        if(this.isNew || this.checkPhotoCredential) this.$refs.credentialDropzone.removeAllFiles()
        if(this.isNew || this.checkPhotoOperator) this.$refs.photoUserDropzone.removeAllFiles()
      }

      if(this.addUserType === 'clients') this.clients = [{name: '', contact: ''}]
    
      this.isNew = true
    },
    defaultFormData() {
      return {
        name: '',
        last_name: '',
        email: '',
        password: '',
        phone: '',
        license_number: '',
        credential_number: '',
        vigenteLicense: new Date().toISOString().slice(0, 10),
        rolId: null,
        company_id: null,
        photoCredential: null,
        photoLicense: null,
        photoLicenseView: null,
        photoCredentialView: null,
        photoUserView: null,
        photoUser: null 
      }
    },
    cleanOptions() {
      this.search = ''
      this.validateGet()
    },
    edit (data) {
      this.isNew = false

      if(this.addUserType === 'clients') return this.editClients(data)

      this.formData = {
        id: data.id,
        name: data.name,
        last_name: data.last_name,
        email: data.email,
        password: '',
        phone: data.phone ? data.phone : '',
        license_number: data.licence_number,
        credential_number: data.credential_number,
        vigenteLicense: data.license_expiration,
        site_ids: data.sites ? data.sites.map(site => site.id) : [],
        photoLicense: null,
        photoCredential: null,
        photoUser: null,
        photoLicenseView: data.licence,
        photoCredentialView: data.credential,
        photoUserView: data.photo_file,
        rolId: null,
        company_id: (this.userLogged.roles && this.userLogged.roles[0].id === 1) ? data.companies[0].id : data.company_id
      }
      
      this.dialogForm = true
    },
    editClients(data){
      this.clients = [{
        id: data.id,
        name: data.name,
        contact: data.contact
      }]

      this.dialogForm = true
    },
    save() {
      if (this.$refs.form.validate()) {
        
        if(this.addUserType === 'clients') return this.isNew ? this.postClients() : this.putClients() 

        this.formData.company_id = (this.userLogged.roles && this.userLogged.roles[0].id === 1) ? this.formData.company_id : this.userLogged.company_id
        
        this.isNew ? this.post() : this.put()
      }
    },
    postClients(){
      this.loadingBtn = true

      this.$store.dispatch('users/postClients', {event: {items: this.clients, context: this}})
    },
    putClients(){
      this.loadingBtn = true
      
      let client = this.clients[0]

      this.$store.dispatch('users/putClient', {event: {item: client, context: this}})
    },
    post () {
      switch (this.addUserType) {
            case 'administrators':
              this.formData.rolId = 2
              this.loadingBtn = true
              this.$store.dispatch('users/post', {event: {item: this.formData, context: this}})
              break
            case 'inspectors':
              this.formData.rolId = 3
              this.loadingBtn = true
              this.$store.dispatch('users/post', {event: {item: this.formData, context: this}})
              break
            case 'operators':
              this.formData.rolId = 4
              this.postOperator()
              break
      }
    },
    async postOperator() {
      this.loadingBtn = true
      
      if(this.formData.photoCredential) this.formData.photoCredential = await this.imageCompressionMethod(this.formData.photoCredential)
      
      if(this.formData.photoLicense) this.formData.photoLicense = await this.imageCompressionMethod(this.formData.photoLicense)
      
      if(this.formData.photoUser) this.formData.photoUser = await this.imageCompressionMethod(this.formData.photoUser)
      
      this.$store.dispatch('users/postOperator', {event: {item: this.formData, context: this}})
    },
    put () {
      switch (this.addUserType) {
            case 'administrators':
              this.formData.rolId = 2
              this.loadingBtn = true
              this.$store.dispatch('users/put', {event: {item: this.formData, context: this}})
              break
            case 'inspectors':
              this.formData.rolId = 3
              this.loadingBtn = true
              this.$store.dispatch('users/put', {event: {item: this.formData, context: this}})
              break
            case 'operators':
              this.putOperator()
              break
      }
    },
    async putOperator() {
      if(this.checkPhotoCredential && this.formData.photoCredential === null) return this.showNotification(this.$t('dropzone.addPhotoRequired'), 'warn', -1)

      if(this.checkPhotoLicense && this.formData.photoLicense === null) return this.showNotification(this.$t('dropzone.addPhotoRequired'), 'warn', -1)
      
      if(this.checkPhotoOperator && this.formData.photoUser === null) return this.showNotification(this.$t('dropzone.addPhotoRequired'), 'warn', -1)
      
      this.loadingBtn = true

      if(!this.checkPhotoCredential) this.formData.photoCredential = null

      if(!this.checkPhotoLicense) this.formData.photoLicense = null

      if(!this.checkPhotoOperator) this.formData.photoUser = null

      if(this.formData.photoCredential) this.formData.photoCredential = await this.imageCompressionMethod(this.formData.photoCredential)
      
      if(this.formData.photoLicense) this.formData.photoLicense = await this.imageCompressionMethod(this.formData.photoLicense)
      
      if(this.formData.photoUser) this.formData.photoUser = await this.imageCompressionMethod(this.formData.photoUser)

      this.$store.dispatch('users/putOperator', {event: {item: this.formData, context: this}})
    },
    deleteItem (){
      this.loading = true
      switch (this.addUserType) {
            case 'administrators':
            case 'inspectors':
              this.$store.dispatch('users/delete', {event: {id: this.removedItem.id, context: this}})
              break
            case 'operators':
              this.$store.dispatch('users/deleteOperator', {event: {id: this.removedItem.id, context: this}})
              break
            case 'clients':
              this.$store.dispatch('users/deleteClients', {event: {id: this.removedItem.id, context: this}})
              break
      }
    },
    validateGet(){
      if(this.optionsDataTable.page === 1) return this.getByTag()
      
      this.optionsDataTable.page = 1
    },
    close () {
      this.dialog = false
      this.loading = false
      this.removedItem = { name: '', last_name: '', roles: [{ name: '' }]}
    },
    searching (i) {
      // si no pasas i, usa el tab actual
      const idx = (typeof i === 'number') ? i : this.tab

      const formRef = this.$refs[`searchValidation_${idx}`]
      const currentForm = Array.isArray(formRef) ? formRef[0] : formRef // por si vuetify envuelve

      if (!currentForm) {
        // El tab aún no está montado (no existe el form)
        return
      }

      if (this.search && !currentForm.validate()) {
        return this.showNotification(this.$t('validation.noSpecialChars'), 'warn', -1)
      }

      currentForm.resetValidation()

      this.validateGet()
    },
    remove(item) {
      this.removedItem = item
      this.dialog = true
    },
    getByTag() {
      if(!this.isFirstCharge && this.loadingTabs === true) return // POR FUNCIONAMIENTO DE DATA_TABLE QUE LANZA DOBLE PETICIONES SE BLOQUEA MANUALMENTE LAS DEMÁS PETICIONES
      
      if(this.isFirstCharge) this.isFirstCharge = false
      this.loadingTabs = true
      switch (this.addUserType) {
        case 'inspectors':
        case 'administrators':
          this.get('users/get')
          break
        case 'clients':
          this.get('users/getClients')
          break
        case 'operators':
          this.get('users/getOperators')
          break
      }
    },
    get (url) {
      this.loadTable = true
      this.$store.dispatch(url, {
        event: {
          page: this.optionsDataTable.page,
          perPage: this.optionsDataTable.itemsPerPage,
          sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'id',
          ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'asc' : 'desc',
          find: this.search,
          role: this.addUserType === 'inspectors' ? 'INSPECTOR' : 'ADMIN',
          context: this
        }
      })
    }
  }
}
</script>

<style scoped>
  #credentialDropzone{
      margin-top: 0px !important;
      border: 1px solid #9E9E9E !important;
      border-radius: 5px;
      padding: 10px;
      color: #665 !important;
  }
  #licenseDropzone{
      margin-top: 0px !important;
      border: 1px solid #9E9E9E !important;
      border-radius: 5px;
      padding: 10px;
      color: #665 !important;
  }
  #photoUserDropzone{
      margin-top: 0px !important;
      border: 1px solid #9E9E9E !important;
      border-radius: 5px;
      padding: 10px;
      color: #665 !important;
  }
  ::v-deep .dz-preview .dz-progress {
    display: none !important;
  }
  ::v-deep .dz-preview .dz-upload {
    display: none !important;
  }
</style>